import { render, staticRenderFns } from "./repeat-custom-form.vue?vue&type=template&id=226f8f99&scoped=true&"
import script from "./repeat-custom-form.vue?vue&type=script&lang=js&"
export * from "./repeat-custom-form.vue?vue&type=script&lang=js&"
import style0 from "./repeat-custom-form.vue?vue&type=style&index=0&id=226f8f99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.7_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226f8f99",
  null
  
)

export default component.exports